import { axiosInstance } from ".";

export const fetchCurrency = async () => {
  try {
    const result = await axiosInstance.get("country/currencies");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchRates = async () => {
  try {
    const result = await axiosInstance.get("new/currency/rates");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
